import { createContext } from 'react';

interface ConfigurationContextType {
    componentConfig: any, 
    setComponentConfig: any
}

const ConfigurationContext = createContext<ConfigurationContextType>({
    componentConfig: {},
    setComponentConfig: () => {}
});

export default ConfigurationContext;